export default __webpack_public_path__ + "static/media/MasaiOneCourseImage3.410ad42a.svg";